import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "interaction-item" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 2,
  class: "interaction-item__description"
}
const _hoisted_5 = { class: "label-xs interaction-item__date" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = {
  key: 1,
  class: "label-xs"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = {
  key: 3,
  class: "interactions-banner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NButton = _resolveComponent("NButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.firstClusterItem)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "interaction-item__thumbnail",
          src: _ctx.firstClusterItem?.thumbnail,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showClusterEventImage([_ctx.firstClusterItem, _ctx.secondClusterItem])))
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.secondClusterItem)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          class: "interaction-item__thumbnail",
          src: _ctx.secondClusterItem?.thumbnail,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showClusterEventImage([_ctx.secondClusterItem, _ctx.firstClusterItem])))
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.firstClusterItem)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$filters.formatDateTime(_ctx.firstClusterItem.created_date)), 1),
          _hoisted_6,
          (_ctx.canPlayVideo)
            ? (_openBlock(), _createBlock(_component_NButton, {
                key: 0,
                icon: "play",
                type: "link",
                onClick: _ctx.playVideo
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.fullCameraName), 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.fullCameraName), 1)),
          _hoisted_8
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('common.loading', 'f')), 1))
  ]))
}